import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { useTooltip } from "./hooks/useTooltip"
import { TooltipAnchor as Anchor, TooltipContainer as Container } from "./styled"
import { positions, positionsList } from "./utils"
/**
 * A Tooltip that can be controlled or appear on hover and have dynamic placement.
 */
export function Tooltip({
  children,
  placement = positions.TOP_RIGHT,
  content,
  show,
  autoFit,
  debounceTimeout = 400,
  variant = "standard",
  className,
  ...props
}) {
  const { containerRef, tooltipRef } = useTooltip(placement, autoFit, show, debounceTimeout)

  const containerClassName = Boolean(show) ? "is-shown" : ""

  return (
    <Anchor ref={containerRef} {...props} data-testid="tooltipContainer" className={className}>
      {children}
      <Container
        ref={tooltipRef}
        role="tooltip"
        $variant={variant}
        className={classNames(className, containerClassName)}
      >
        {content}
      </Container>
    </Anchor>
  )
}

Tooltip.propTypes = {
  /**
   * One of the 8 placement options, If autoFit the preferrable placement
   */
  placement: PropTypes.oneOf(positionsList),
  /**
   * The children will be the anchor of the tooltip so it is required
   */
  children: PropTypes.node.isRequired,
  /**
   * The content that will appear on the container itself
   */
  content: PropTypes.node,
  /**
   * If not undefined it will be controlled by the prop
   */
  show: PropTypes.bool,
  /**
   * If true if a placement would overflow the next clockwise will be used
   */
  autoFit: PropTypes.bool,
  /**
   * The number to debounce the listeners
   * @default 400
   */
  debounceTimeout: PropTypes.number,
  /**
   * One of the defined variants
   *
   * @default standard
   */
  variant: PropTypes.string,
}
